import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

export const firebaseConfig = {
    apiKey: "AIzaSyBGP-1u32PrdQqzHRNEB2AeyQlx_xZZafw",
    authDomain: "productivity-d4bde.firebaseapp.com",
    projectId: "productivity-d4bde",
    storageBucket: "productivity-d4bde.appspot.com",
    messagingSenderId: "565473069691",
    appId: "1:565473069691:web:fb4b03205bc6620d1b70de",
    measurementId: "G-GQNQC2GGTB"
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
